import {
    Backdrop,
    Button,
    Grid,
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Checkbox,
    CircularProgress,
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import DoneIcon from '@material-ui/icons/Done';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import MuiAlert from '@material-ui/lab/Alert';
import Moment from 'moment/moment';
import React, { Component } from 'react';
import { Animated } from 'react-animated-css';
import { connect } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import { Link, withRouter } from 'react-router-dom';
import join from 'url-join';
import axios, { safeGet } from '../axios-default';
import { ApiServerUrl } from '../config.json';
import { withLang, getFromObj } from '../util/lang';
import externalCss from './css/patientInfo.module.css';
import { easySnackbar } from '../store/Noti/noti.actions';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles } from '@material-ui/core/styles';
import Treatment from '../components/NewPatient/Photos/TreatmentPlan';
import Modal from '../components/Modal/modal';
import PercentageProgressRing from '../components/PercentageProgressRing';
import EditIcon from '@material-ui/icons/Edit';
import { getWebAbsPath } from '../util/path';
import NotificationDialog from '../components/Dialog/NotificationDialog';
import { updateNotification } from '../store/Auth/Auth.action';
import Banner from '../components/Banner';
import {
    setIsClinicalSmulationApproveTreatmentPlan,
    setPlanId,
    smileDesignProductListArray,
} from '../store/SmileDesign/SmileDesignSlice';
import { ERROR } from '../util/const';
import { CASE_TYPE } from '../store/NewPatient/utils';
import { isValidUrl } from '../util/function';
import { getIsHideModifyPanel } from './PatientInfo_util';
import ClinicalApprovementModal from './SmileDesign/Modal/ClinicalApprovementModal/ClinicalApprovementModal';
import { openModal } from '../store/Global/global';
import UpgradeAlignerCaseTypeModal from '../components/Modal/UpgradeAlignerCaseTypeModal';
import { getIsCaseNoCaseTypeUpgrade } from '../api/userTest';
import ClinicalRequesMultipleModalButtons from './SmileDesign/Modal/ClinicalRequesMultipleModalButtons/ClinicalRequesMultipleModalButtons';
import LoadingSpinner from '../components/Loader/LoadingSpinner';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ExpansionPanel = withStyles({
    root: {
        border: '1px solid rgba(0,0,0,.125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        marginBottom: '10px',
    },
    expanded: {
        margin: 'auto',
        paddingBottom: '10px',
    },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0,0,0,.03)',
        borderBottom: '1px solid rgba(0,0,0,.125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        margin: '0px 0',
        '&$expanded': {
            margin: '0px 0',
        },
    },
    expanded: {},
})((props) => <MuiExpansionPanelSummary {...props} />);

const ExpansionPanelDetails = withStyles((theme) => ({
    root: {
        padding: '10px 10px 0',
    },
}))(MuiExpansionPanelDetails);

ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

class TreatmentApproval extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientInfo: {
                case_id: '',
                case_status: '',
                case_type: '',
                first_name: '',
                last_name: '',
                patient_id: '',
                promotion_code: '',
            },
            treatment_plan: [],
            caseId: this.props.match.params.id,
            patientId: this.props.match.params.patientsid,
            caseType: '',
            role: JSON.parse(localStorage.getItem('role')),
            error: '',
            latestApprovedPlan: {},
            distrData: [],
            TreatmentModal: false,
            TreatmentApprovalModal: false,
            distrAlertMsg1: false,
            distrAlertMsg2: false,
            distrMissingMsg: true,
            currentTreatmentPlanIDforModal: '',
            isLoading: false,
            loadingOnMount: false,
            treatmentPlan: {
                pdf1: null,
                pdf1_label: '',
                pdf2: null,
                pdf2_label: '',
                video1: null,
                video1_label: '',
                video2: null,
                video2_label: '',
                smile_3d: '',
                treatment_approval: true,
                caseStatus: '',
            },
            defect_resubmit_flag: false,
            promotionCode: '',
            isPromotionCodeValid: true,
            popupConfirmUrl: '',
            showPopup: false,
            notificationContent: [],
            notificationCheckbox: false,
            openUpgradeTreatmentPlanModal: false,
            openUpgradeTreatmentPlanMultiPlanModal: false,
            selectedPlanId: null,
            selectedInMultiPlanId: null,
            isProcessing: false,
        };
        this.progressBarRef = React.createRef(null);
        this.handleOpen = this.handleOpen.bind(this);
    }

    handleChecked(field, value) {
        if (field === 'msg1') {
            this.setState({ distrAlertMsg1: value }, () => {
                if (this.state.distrAlertMsg1 && this.state.distrAlertMsg2) {
                    this.setState({ distrMissingMsg: false });
                } else {
                    this.setState({ distrMissingMsg: true });
                }
            });
        }
        if (field === 'msg2') {
            this.setState({ distrAlertMsg2: value }, () => {
                if (this.state.distrAlertMsg1 && this.state.distrAlertMsg2) {
                    this.setState({ distrMissingMsg: false });
                } else {
                    this.setState({ distrMissingMsg: true });
                }
            });
        }
    }

    handleOpen(modalType, ModalTypeState = 'view', args) {
        switch (modalType) {
            case 'treatment':
                this.setState({ TreatmentModal: true, ModalState: ModalTypeState });
                break;
            case 'treatment_approval':
                this.setState({ TreatmentApprovalModal: true, ModalState: ModalTypeState });
                break;
        }
    }
    handleClose(modalType) {
        let defaultState = { modalError: '', targetId: null };
        switch (modalType) {
            case 'treatment':
                defaultState = { ...defaultState, TreatmentModal: false };
                break;
            case 'treatment_approval':
                defaultState = { ...defaultState, TreatmentApprovalModal: false };

                break;
        }
        this.setState(defaultState);
    }

    async handleTreatmentData(data = null, stateType, fileName) {
        let newtreatmentPlan = { ...this.state.treatmentPlan };
        switch (stateType) {
            case 'pdf1':
                newtreatmentPlan.pdf1 = data;
                newtreatmentPlan.pdf1_label = fileName;
                this.setState({ treatmentPlan: newtreatmentPlan });
                break;
            case 'pdf2':
                newtreatmentPlan.pdf2 = data;
                newtreatmentPlan.pdf2_label = fileName;
                this.setState({ treatmentPlan: newtreatmentPlan });
                break;
            case 'video1':
                newtreatmentPlan.video1 = data;
                newtreatmentPlan.video1_label = fileName;
                this.setState({ treatmentPlan: newtreatmentPlan });
                break;
            case 'video2':
                newtreatmentPlan.video2 = data;
                newtreatmentPlan.video2_label = fileName;
                this.setState({ treatmentPlan: newtreatmentPlan });
                break;
            case 'smile_3d':
                newtreatmentPlan.smile_3d = data;
                this.setState({ treatmentPlan: newtreatmentPlan });
                break;
            case 'treatment_approval':
                newtreatmentPlan.treatment_approval = data;
                this.setState({ treatmentPlan: newtreatmentPlan });
                break;
        }
    }

    async handleTreatmentSave() {
        const form = new FormData();
        let treatmentData = {
            pdf0: this.state.treatmentPlan.pdf1 ? '$$FILE:pdf0' : null,
            pdf0_name: this.state.treatmentPlan.pdf1_label,
            pdf1: this.state.treatmentPlan.pdf2 ? '$$FILE:pdf1' : null,
            pdf1_name: this.state.treatmentPlan.pdf2_label,
            video0: this.state.treatmentPlan.video1 ? '$$FILE:video0' : null,
            video0_name: this.state.treatmentPlan.video1_label,
            video1: this.state.treatmentPlan.video2 ? '$$FILE:video1' : null,
            video1_name: this.state.treatmentPlan.video2_label,
            url: this.state.treatmentPlan.smile_3d,
            myo_oid: this.state.treatmentPlan.myo_oid,
            myo_pid: this.state.treatmentPlan.myo_pid,
            myo_id: this.state.treatmentPlan.myo_id,
            myo_token: this.state.treatmentPlan.myo_token,
        };
        let isFileUploaded = false;
        if (this.state.treatmentPlan.pdf1) {
            form.append('$$FILE:pdf0', this.state.treatmentPlan.pdf1);
            isFileUploaded = true;
        }
        if (this.state.treatmentPlan.pdf2) {
            form.append('$$FILE:pdf1', this.state.treatmentPlan.pdf2);
            isFileUploaded = true;
        }

        if (this.state.treatmentPlan.video1) {
            form.append('$$FILE:video0', this.state.treatmentPlan.video1);
            isFileUploaded = true;
        }
        if (this.state.treatmentPlan.video2) {
            form.append('$$FILE:video1', this.state.treatmentPlan.video2);
            isFileUploaded = true;
        }
        if (this.state.treatmentPlan.smile_3d && this.state.treatmentPlan.smile_3d != '~pending upload~') {
            //if smile 3d have value
            isFileUploaded = true;
        }

        if (!isFileUploaded) {
            alert('No any file uploaded, please check and save again.');
            return;
        }

        form.append('body', JSON.stringify(treatmentData));
        //console.log(treatmentData);
        try {
            this.setState({ isProcessing: true });
            await axios.put(
                `case/treatment_plan/${this.state.caseId}/${this.state.currentTreatmentPlanIDforModal}`,
                form,
                {
                    onUploadProgress: this.progressBarRef.current?.onProgressChange,
                }
            );
            await this.props.showSnackbar(
                getFromObj(this.props.lang, 'dict.pages.treatmentapproval.treatment_plan_uploaded'),
                'success',
                true
            );
            this.reloadPage();
        } catch (err) {
            const errMsg = this.getErrorMsg(err, 'Something Went Wrong Please Connect With Admin');
            this.setState({
                modalError: errMsg,
            });
            console.error(err.response);
        } finally {
            this.setState({ isProcessing: false });
        }
    }

    reloadPage() {
        this.props.history.push('/blank');
        this.props.history.replace(`/patients/${this.state.caseId}/treatment`);
    }

    async componentDidMount() {
        let id = parseInt(this.state.caseId);
        try {
            this.setState({ loadingOnMount: true });
            // get the case data in case need to upload new 3d simulation file.
            const caseData = await safeGet(`case/treatment_plan_approval/${id}`);
            // redirect user if case is cancelled
            if (!caseData.success && caseData.message === ERROR.CASE_CANCELLED) {
                this.props.openRedirectUserModal({
                    title: this.get('@PatientInfo.msg.caseCancelledTitle'),
                    message: this.get('@PatientInfo.msg.caseCancelledMessage'),
                    modalOnCloseCallbackFunc: () => this.props.history.push('/'),
                    showOk: false,
                });
                return;
            }
            const _case = caseData?.data || this.state.patientInfo;
            const patientInfoData = {
                id: _case.case_id,
                firstName: _case.first_name,
                lastName: _case.last_name,
                case_status: _case.case_status,
                case_type: _case.case_type,
            };

            let patientId = _case.patient_id;
            let caseStatus = _case.case_status;

            this.setState({ caseStatus: caseStatus });
            this.setState({ patientId: patientId });

            // get notification data
            let noti_array = [];
            const result = await axios.get('/notification/get_content/idesign_new_feature');
            if (result && result.data && result.data.content && Array.isArray(result.data.content)) {
                let content = result.data.content;
                // check if user has confirmed each notification content, show content if not confirmed
                for (let i = 0; i < content.length; i++) {
                    if (
                        !localStorage.notification ||
                        !localStorage.notification.split(',').includes(content[i].notification_id.toString())
                    ) {
                        noti_array.push(content[i]);
                    }
                }
            }
            this.setState({ notificationContent: noti_array });

            let TreatmentPlanData = (await axios.get(`case/treatment_plan/${this.state.caseId}/treatment`)).data
                .treatment_plan;
            this.setState({ treatment_plan: TreatmentPlanData });
            this.setState({
                latestApprovedPlan:
                    _case.case_type === CASE_TYPE.SELF_DESIGN
                        ? ((TreatmentPlanData || [])
                              .flat()
                              .filter((plan) => plan?.approved_flag)
                              .sort(
                                  (a, b) =>
                                      new Date(b.approval_date || b.created_date || 0).getTime() -
                                          new Date(a.approval_date || a.created_date || 0).getTime() ||
                                      (b.plan_id || 0) - (a.plan_id || 0)
                              )[0] ?? {})
                        : (TreatmentPlanData[TreatmentPlanData.length - 1]?.find((plan) => plan.approved_flag) ?? {}),
            });

            let res = await safeGet(`distrmsg/getdistrmsg`);
            this.setState({ distrData: res.dm });
            // const promotionCodeRes = await axios.get(`case/promotionCode/${_case.case_id}`);
            this.setState({
                patientInfo: patientInfoData,
                promotionCode: _case.promotion_code,
                caseType: _case.case_type,
            });
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({ loadingOnMount: false });
        }
    }

    async handleChangeStatus(plan_id) {
        // var isValid = true;
        if (this.state.promotionCode) {
            // const validRes = await axios.get(`/case/promotionCode/invalid/${this.state.caseId}`);
            // isValid = validRes.data.valid;
            // this.setState({ isPromotionCodeValid: validRes.data.valid });
            this.setState({ isPromotionCodeValid: true });
        }

        if (
            this.state.distrData.length > 0 &&
            this.state.distrData[0].enable_flag === true &&
            !this.state.TreatmentApprovalModal
        ) {
            //enableDistrAlertModel
            this.setState({ TreatmentApprovalModal: true });
            // } else if ((this.state.distrData.length === 0 || this.state.distrData[0].enable_flag === false) && !this.state.TreatmentApprovalModal && !isValid) {
            //   this.handleChecked('msg1', true);
            //   this.handleChecked('msg2', true);
            //   this.setState({ TreatmentApprovalModal: true })
        } else {
            let question = 'Are you sure you want to approve this treatment plan?';

            let result = window.confirm(question);
            if (result) {
                this.handlePostApprovePlan(
                    plan_id,
                    this.state.isPromotionCodeValid && !this.state.promotionCode.includes('Invalid')
                );
            }
        }
    }

    async handlePostApprovePlan(plan_id, isValid) {
        try {
            this.setState({ isLoading: true });
            await axios.post(`case/${this.state.caseId}/treatment_plan/${plan_id}/approve`, {});
            // if (isValid) {
            if (this.state.promotionCode && this.state.promotionCode.length) {
                axios.post(`/case/promotionCode/uselog/${this.state.caseId}`, {
                    promotionCode: this.state.promotionCode,
                });
                // }else{
                //   axios.post(`/case/promotionCode/invalid/${this.state.caseId}`);
            }
            await this.props.showSnackbar(
                //`Treatment plan #${plan_id} approved`
                getFromObj(this.props.lang, 'dict.pages.treatmentapproval.treatment_plan_approved').replace(
                    /\{No[^\}]*\?\}/,
                    plan_id
                ),
                'success',
                true
            );
            this.props.history.push('/blank');
            // this.props.history.replace(`/patients/${this.state.patientId}/${this.state.caseId}/View`);
            this.props.history.replace(`/patients/${this.state.caseId}`);
        } catch (e) {
            this.setState({ isLoading: false });
            const errMsg = this.getErrorMsg(e, 'Cannot change the status please connect with admin');
            this.setState({
                error: errMsg,
            });
            console.error(e.response);
        }
    }
    async handleUndoApproval(plan_id) {
        let result = window.confirm('Are you sure you want to undo this treatment plan approval?');
        if (result) {
            try {
                await axios.post(`case/${this.state.caseId}/treatment_plan/${plan_id}/undo`, {});
                await this.props.showSnackbar(`Treatment plan #${plan_id} approval is undone`, 'success', true);
                this.props.history.push('/blank');
                // this.props.history.replace(`/patients/${this.state.patientId}/${this.state.caseId}/View`);
                this.props.history.replace(`/patients/${this.state.caseId}`);
            } catch (e) {
                const errMsg = this.getErrorMsg(e, 'Cannot change the status please connect with admin');
                this.setState({
                    error: errMsg,
                });
                console.error(e.response);
            }
        }
    }

    modifyHideInterware(tpApprovedFlag = false) {
        let isHideModifyPanel = getIsHideModifyPanel(this.state.caseStatus, tpApprovedFlag);
        return isHideModifyPanel ? '&modifyHide=true' : '';
    }
    modifyHideRayFace(tpApprovedFlag = false) {
        let isHideModifyPanel = getIsHideModifyPanel(this.state.caseStatus, tpApprovedFlag);
        return isHideModifyPanel ? '&hidden=1' : '';
    }

    handleNotificationSave = async () => {
        let notification_ids = this.state.notificationContent.map((v) => v.notification_id);
        if (this.state.notificationCheckbox) {
            await axios.post('/notification/confirm_notification', { notification_ids });
            await updateNotification();
        }
    };

    fileMapping() {
        const fileMappings = {
            pdf0_name: {
                key: 'pdf0_name',
                value: getFromObj(this.props.lang, 'dict.pages.treatmentapproval.analysis'),
            },
            pdf1_name: {
                key: 'pdf1_name',
                value: getFromObj(this.props.lang, 'dict.pages.treatmentapproval.treatment_plan'),
            },
            video0_name: {
                key: 'video0_name',
                value: getFromObj(this.props.lang, 'dict.pages.treatmentapproval.buccal_view_video'),
            },
            video1_name: {
                key: 'video1_name',
                value: getFromObj(this.props.lang, 'dict.pages.treatmentapproval.occlusal_view_video'),
            },
            smileDesignPPT_name: {
                key: 'smileDesignPPT_name',
                value: this.get('@pages.treatmentapproval.smileReport'),
            },
            smileDesign_exocad_pre_name: {
                key: 'smileDesign_exocad_pre_name',
                value: this.get(`@pages.treatmentapproval.exocadDesign`),
            },
            // !Explain: only show one button instead of two so comment out one of them
            // "smileDesign_exocad_post_name":{
            //   key: 'smileDesign_exocad_post_name',
            //   value: 'EXOCAD Post'
            // }
        };

        return fileMappings;
    }

    fileExist(row, item) {
        const fileMapping = this.fileMapping()[item];
        // Debug
        // console.log('fileMapping', fileMapping);
        if (
            fileMapping &&
            row[fileMapping.key] !== '' &&
            row[fileMapping.key] !== null &&
            row[fileMapping.key] !== undefined
        ) {
            return fileMapping.value;
        } else {
            return false;
        }
    }

    renderSelfDesignSimulationRow(plan) {
        if (this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN || !plan?.plan_no) return null;
        return (
            <TableRow>
                <TableCell align="center">
                    <a
                        href={getWebAbsPath(
                            `meditReview/${this.state.caseId}?planNo=${encodeURIComponent(plan.plan_no)}`
                        )}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            textDecoration: 'none',
                            color: '#4d4dbf',
                        }}
                    >
                        {this.get('treatmentPlan.designSimulation')}
                    </a>
                </TableCell>
                <TableCell align="center">
                    {plan?.created_date ? Moment(plan.created_date).format('DD MMM YYYY') : '-'}
                </TableCell>
                <TableCell align="center">{plan?.['approved_flag'] ? <DoneIcon /> : <ErrorOutlineIcon />}</TableCell>
                <TableCell align="center">
                    {plan?.['approval_date']
                        ? Moment(plan?.['approval_date']).format('YYYY-MM-DD')
                        : getFromObj(this.props.lang, 'dict.pages.treatmentapproval.notapproved')}
                </TableCell>
            </TableRow>
        );
    }

    async handleApproveTreatmentPlan(planId) {
        const isCaseNoCaseTypeUpgrade = await getIsCaseNoCaseTypeUpgrade(this.state.caseId, planId);
        if (smileDesignProductListArray.includes(this.state.caseType)) {
            // Change to check isSmilDesign
            this.props.setIsClinicalSmulationApproveTreatmentPlan(true);
        } else if (isCaseNoCaseTypeUpgrade) {
            this.handleChangeStatus(this.state.latestApprovedPlan?.['plan_id']);
        } else {
            this.setState({ openUpgradeTreatmentPlanModal: true });
        }
    }

    async handleApproveTreatmentPlanFromMultiplePlan(row) {
        this.setState({ selectedInMultiPlanId: row['plan_id'] });
        const isCaseNoCaseTypeUpgrade = await getIsCaseNoCaseTypeUpgrade(this.state.caseId, row['plan_id']);

        if (smileDesignProductListArray.includes(this.state.caseType)) {
            // Change to check isSmilDesign
            this.props.setIsClinicalSmulationApproveTreatmentPlan(true);
            this.props.setPlanId(row['plan_id']);
        } else if (isCaseNoCaseTypeUpgrade) {
            this.setState({
                currentTreatmentPlanIDforModal: row['plan_id'],
            });
            this.handleChangeStatus(row['plan_id']);
        } else {
            this.setState({
                openUpgradeTreatmentPlanMultiPlanModal: this.state.selectedInMultiPlanId === row['plan_id'],
            });
        }
    }

    render() {
        const approvedRefinement = []; //new Set([])
        this.state.treatment_plan.forEach((refinement, i) => {
            approvedRefinement.push(new Set([]));
            if (refinement) {
                refinement.forEach((plan) => {
                    if (plan?.approved_flag) {
                        approvedRefinement[i].add(plan.refinement_no);
                    }
                });
            }
        });

        return (
            <>
                <Backdrop style={{ zIndex: 9999, color: '#fff' }} open={this.state.isLoading}>
                    <LoadingSpinner />
                </Backdrop>

                <Modal
                    className="modal"
                    modal="Distr form"
                    title="Trioclear Platform Message"
                    open={this.state.TreatmentApprovalModal}
                    handleClose={() => this.handleClose('treatment_approval')}
                    handleDataSave={() => {
                        this.state.distrAlertMsg1 && this.state.distrAlertMsg2
                            ? this.handleChangeStatus(this.state.currentTreatmentPlanIDforModal)
                            : this.setState({ distrMissingMsg: true });
                    }}
                    submitButton={true}
                >
                    {this.state.distrData.length > 0 && this.state.distrData[0].enable_flag === true ? (
                        <>
                            <FormControlLabel
                                control={<Checkbox checked={this.state.distrAlertMsg1} />}
                                label={this.state.distrData[0] && this.state.distrData[0].msg1}
                                labelPlacement="end"
                                onChange={(e) => this.handleChecked('msg1', e.target.checked)}
                            />
                            <br />
                            <FormControlLabel
                                control={<Checkbox checked={this.state.distrAlertMsg2} />}
                                label={this.state.distrData[0] && this.state.distrData[0].msg2}
                                labelPlacement="end"
                                onChange={(e) => this.handleChecked('msg2', e.target.checked)}
                            />
                        </>
                    ) : (
                        ''
                    )}

                    {!this.state.isPromotionCodeValid ||
                    (this.state.promotionCode && this.state.promotionCode.includes('Invalid')) ? (
                        <>
                            <p>
                                The promotion code you entered was not valid. Please note that the promotion code can
                                only be used once.
                            </p>
                            <p>Do you still want to confirm the treatment plan?</p>
                        </>
                    ) : (
                        <p>Confirm to approve the Treatment plan?</p>
                    )}

                    <br />
                    {this.state.distrMissingMsg && <p>Please accept the above statement</p>}
                </Modal>
                <NotificationDialog
                    title="@NotificationDialog.new_feature_popup.title"
                    content={this.state.notificationContent}
                    showPopup={this.state.showPopup}
                    setShowPopup={(v) => this.setState({ showPopup: v })}
                    notificationCheckbox={this.state.notificationCheckbox}
                    setNotificationCheckbox={(v) => this.setState({ notificationCheckbox: v })}
                    onConfirm={() => this.handleNotificationSave()}
                    onClose={() => window.open(this.state.popupConfirmUrl, '_blank')}
                    moreDetailText="@NotificationDialog.new_feature_popup.more_detail"
                    moreDetailLink="@NotificationDialog.new_feature_popup.more_detail_link"
                />
                <Animated animationIn="fadeIn" isVisible={true}>
                    <PercentageProgressRing ref={this.progressBarRef} open={this.state.isProcessing} />
                    <Grid container style={{ padding: 16, background: '#f2f2f2' }}>
                        <Banner />

                        <Grid item xs={12}>
                            <div
                                style={{
                                    margin: '8px 0px',
                                }}
                            >
                                <Link
                                    to="/"
                                    style={{
                                        color: 'black',
                                    }}
                                >
                                    {this.get('breadcrumbs.caseManagement')}
                                </Link>
                                {` > ${this.get('breadcrumbs.patient')} #${this.props.match.params.id}`}
                            </div>
                        </Grid>

                        {this.props.history.length > 1 && (
                            <Button
                                onClick={() => this.props.history.goBack()}
                                variant="outlined"
                                style={{
                                    margin: '8px 0px',
                                    minWidth: 128,
                                }}
                            >
                                <ArrowBackIosIcon />
                                {this.get(':const.back')}
                            </Button>
                        )}

                        <Grid item xs={12}>
                            {this.state.error && (
                                <Alert severity="error" style={{ marginBottom: '30px' }}>
                                    {this.state.error}
                                </Alert>
                            )}
                            {!Array.isArray(this.state.treatment_plan[0]) ||
                            this.state.treatment_plan[0].length === 0 ? (
                                <Grid container>
                                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                                        {this.state.loadingOnMount ? (
                                            <LoadingSpinner />
                                        ) : (
                                            <>
                                                <p>{this.get('treatmentPlan.noTreatmentPlan')}</p>
                                                <img
                                                    src={getWebAbsPath('/img/noData.png')}
                                                    style={{ width: '100%', maxWidth: 600 }}
                                                />
                                            </>
                                        )}
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6}>
                                        <h3>
                                            {getFromObj(
                                                this.props.lang,
                                                'dict.pages.treatmentapproval.latest_approved_plan'
                                            )}
                                        </h3>
                                        <Modal
                                            className="modal"
                                            modal="treatmentPlan"
                                            title="Treatment Plan"
                                            open={this.state.TreatmentModal && !this.state.isLoading}
                                            handleClose={() => this.handleClose('treatment')}
                                            handleDataSave={() => this.handleTreatmentSave()}
                                            submitButton={true}
                                            PhotoUploadLoadingStatus={this.state.isProcessing}
                                            modalError={this.state.modalError}
                                        >
                                            {
                                                <Treatment
                                                    patientInfo={this.state.patientInfo}
                                                    treatmentPlan={this.state.treatmentPlan}
                                                    handleTreatmentData={(data, stateType, fileName) =>
                                                        this.handleTreatmentData(data, stateType, fileName)
                                                    }
                                                />
                                            }
                                        </Modal>
                                        {Object.keys(this.state.latestApprovedPlan).length != 0 ? (
                                            <>
                                                <TableContainer component={Paper}>
                                                    <FormControl className={externalCss.radioFieldset}>
                                                        <Grid container>
                                                            <Grid
                                                                item
                                                                xs={12}
                                                                style={{
                                                                    backgroundColor: this.state.latestApprovedPlan?.[
                                                                        'approved_flag'
                                                                    ]
                                                                        ? '#a7d2a5'
                                                                        : '#c7c7c7',
                                                                }}
                                                            >
                                                                <div className={externalCss.plan}>
                                                                    <p>
                                                                        {getFromObj(
                                                                            this.props.lang,
                                                                            'dict.pages.treatmentapproval.treatment_plan_status'
                                                                        ).replace(
                                                                            /\{No[^\}]*\?\}/,
                                                                            this.state.latestApprovedPlan?.plan_no
                                                                        )}
                                                                        {this.state.latestApprovedPlan?.[
                                                                            'approved_flag'
                                                                        ]
                                                                            ? getFromObj(
                                                                                  this.props.lang,
                                                                                  'dict.pages.treatmentapproval.approved'
                                                                              )
                                                                            : getFromObj(
                                                                                  this.props.lang,
                                                                                  'dict.pages.treatmentapproval.notapproved'
                                                                              )}
                                                                    </p>
                                                                    {['ADMIN', 'SADMIN', 'DISTR'].includes(
                                                                        this.state.role
                                                                    ) &&
                                                                        this.state.latestApprovedPlan?.[
                                                                            'approved_flag'
                                                                        ] &&
                                                                        this.state.caseStatus === 'PLAN_APPROVED' && (
                                                                            <Button
                                                                                variant="outlined"
                                                                                onClick={() =>
                                                                                    this.handleUndoApproval(
                                                                                        this.state.latestApprovedPlan?.[
                                                                                            'plan_id'
                                                                                        ]
                                                                                    )
                                                                                }
                                                                                style={{
                                                                                    backgroundColor: ![
                                                                                        'ADMIN',
                                                                                        'SADMIN',
                                                                                        'DISTR',
                                                                                    ].includes(this.state.role)
                                                                                        ? '#455793'
                                                                                        : '#b14f4f',
                                                                                    color: 'white',
                                                                                }}
                                                                            >
                                                                                {this.get(
                                                                                    'treatmentPlan.undoPlanApproval'
                                                                                )}
                                                                            </Button>
                                                                        )}
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <div>
                                                                    {!['ADMIN', 'SADMIN', 'DISTR'].includes(
                                                                        this.state.role
                                                                    ) &&
                                                                        !this.state.latestApprovedPlan?.[
                                                                            'approved_flag'
                                                                        ] &&
                                                                        !approvedRefinement?.has?.(
                                                                            this.state.latestApprovedPlan?.refinement_no
                                                                        ) &&
                                                                        this.state.patientInfo?.case_status ===
                                                                            'PLAN_UPLOADED' && (
                                                                            <>
                                                                                <Button
                                                                                    variant="outlined"
                                                                                    onClick={() =>
                                                                                        this.handleApproveTreatmentPlan(
                                                                                            this.state
                                                                                                .latestApprovedPlan?.[
                                                                                                'plan_id'
                                                                                            ]
                                                                                        )
                                                                                    }
                                                                                    style={{
                                                                                        backgroundColor: ![
                                                                                            'ADMIN',
                                                                                            'SADMIN',
                                                                                            'DISTR',
                                                                                        ].includes(this.state.role)
                                                                                            ? '#455793'
                                                                                            : '#b14f4f',
                                                                                        color: 'white',
                                                                                    }}
                                                                                >
                                                                                    {this.get(
                                                                                        'treatmentPlan.approvePlan'
                                                                                    )}
                                                                                </Button>
                                                                                <ClinicalApprovementModal
                                                                                    caseId={this.state.caseId}
                                                                                    planId={
                                                                                        this.state.latestApprovedPlan?.[
                                                                                            'plan_id'
                                                                                        ]
                                                                                    }
                                                                                />
                                                                                <UpgradeAlignerCaseTypeModal
                                                                                    openExtenal={
                                                                                        this.state
                                                                                            .openUpgradeTreatmentPlanModal
                                                                                    }
                                                                                    handleOpenExternal={this.setState({
                                                                                        openUpgradeTreatmentPlanModal: false,
                                                                                    })}
                                                                                    planId={
                                                                                        this.state.latestApprovedPlan?.[
                                                                                            'plan_id'
                                                                                        ]
                                                                                    }
                                                                                    caseId={this.state.caseId}
                                                                                />
                                                                            </>
                                                                        )}
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </FormControl>

                                                    <Table aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center">
                                                                    {this.get('treatmentPlan.fileName')}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {this.get('treatmentPlan.submissionDate')}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {this.get('treatmentPlan.approved')}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {this.get('treatmentPlan.approvedDate')}
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {this.state.latestApprovedPlan?.['url'] && (
                                                                <TableRow>
                                                                    <TableCell align="center">
                                                                        {!this.state.isLoading &&
                                                                            (/^https?:\/\/.*idesign\./.test(
                                                                                this.state.latestApprovedPlan?.['url']
                                                                            ) ||
                                                                            /^https?:\/\/.*idesigndev\./.test(
                                                                                this.state.latestApprovedPlan?.['url']
                                                                            ) ? (
                                                                                <a
                                                                                    href="#"
                                                                                    onClick={(event) => {
                                                                                        event.preventDefault();
                                                                                        !this.state
                                                                                            .notificationContent ||
                                                                                        !this.state.notificationContent
                                                                                            .length
                                                                                            ? window.open(
                                                                                                  this.state
                                                                                                      .latestApprovedPlan?.[
                                                                                                      'url'
                                                                                                  ] +
                                                                                                      this.modifyHideRayFace(
                                                                                                          this.state
                                                                                                              .latestApprovedPlan?.[
                                                                                                              'approved_flag'
                                                                                                          ]
                                                                                                      ),
                                                                                                  '_blank'
                                                                                              )
                                                                                            : this.setState({
                                                                                                  popupConfirmUrl:
                                                                                                      this.state
                                                                                                          .latestApprovedPlan?.[
                                                                                                          'url'
                                                                                                      ] +
                                                                                                      this.modifyHideRayFace(
                                                                                                          this.state
                                                                                                              .latestApprovedPlan?.[
                                                                                                              'approved_flag'
                                                                                                          ]
                                                                                                      ),
                                                                                                  showPopup: true,
                                                                                              });
                                                                                    }}
                                                                                    style={{
                                                                                        textDecoration: 'none',
                                                                                        color: '#4d4dbf',
                                                                                    }}
                                                                                >
                                                                                    {this.get(
                                                                                        'treatmentPlan.view_3DSimulation'
                                                                                    )}
                                                                                </a>
                                                                            ) : (
                                                                                <a
                                                                                    href={
                                                                                        this.state.latestApprovedPlan?.[
                                                                                            'url'
                                                                                        ] +
                                                                                        '&userid=' +
                                                                                        JSON.parse(
                                                                                            localStorage.getItem(
                                                                                                'auth-token'
                                                                                            )
                                                                                        ) +
                                                                                        this.modifyHideInterware(
                                                                                            this.state
                                                                                                .latestApprovedPlan?.[
                                                                                                'approved_flag'
                                                                                            ]
                                                                                        )
                                                                                    }
                                                                                    target="_blank"
                                                                                    style={{
                                                                                        textDecoration: 'none',
                                                                                        color: '#4d4dbf',
                                                                                    }}
                                                                                >
                                                                                    {this.get(
                                                                                        'treatmentPlan.view_3DSimulation'
                                                                                    )}
                                                                                </a>
                                                                            ))}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {Moment(
                                                                            this.state.latestApprovedPlan?.[
                                                                                'created_date'
                                                                            ]
                                                                        ).format('DD MMM YYYY')}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {this.state.latestApprovedPlan?.[
                                                                            'approved_flag'
                                                                        ] ? (
                                                                            <DoneIcon />
                                                                        ) : (
                                                                            <ErrorOutlineIcon />
                                                                        )}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {this.state.latestApprovedPlan?.[
                                                                            'approval_date'
                                                                        ]
                                                                            ? Moment(
                                                                                  this.state.latestApprovedPlan?.[
                                                                                      'approval_date'
                                                                                  ]
                                                                              ).format('YYYY-MM-DD')
                                                                            : getFromObj(
                                                                                  this.props.lang,
                                                                                  'dict.pages.treatmentapproval.notapproved'
                                                                              )}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )}
                                                            {this.renderSelfDesignSimulationRow(
                                                                this.state.latestApprovedPlan
                                                            )}
                                                            {/* latest approved plan */}
                                                            {Object.keys(this.state.latestApprovedPlan).map(
                                                                (key1, index1) =>
                                                                    this.fileExist(
                                                                        this.state.latestApprovedPlan,
                                                                        key1
                                                                    ) && (
                                                                        <TableRow>
                                                                            {key1 !== 'url' ? (
                                                                                <TableCell align="center">
                                                                                    {[
                                                                                        this.fileMapping()?.[
                                                                                            'smileDesign_exocad_pre_name'
                                                                                        ]?.key,
                                                                                    ].includes(key1) ? (
                                                                                        <a
                                                                                            href={`${window.location.origin}/clinicalSimulation/${this.state.caseId}`}
                                                                                            target="_blank"
                                                                                            style={{
                                                                                                textDecoration: 'none',
                                                                                                color: '#4d4dbf',
                                                                                            }}
                                                                                        >
                                                                                            {this.fileExist(
                                                                                                this.state
                                                                                                    .latestApprovedPlan,
                                                                                                key1
                                                                                            )}
                                                                                        </a>
                                                                                    ) : (
                                                                                        <a
                                                                                            href={join(
                                                                                                ApiServerUrl,
                                                                                                this.state
                                                                                                    .latestApprovedPlan?.[
                                                                                                    key1.replace(
                                                                                                        '_name',
                                                                                                        ''
                                                                                                    )
                                                                                                ]
                                                                                            )}
                                                                                            target="_blank"
                                                                                            style={{
                                                                                                textDecoration: 'none',
                                                                                                color: '#4d4dbf',
                                                                                            }}
                                                                                        >
                                                                                            {this.fileExist(
                                                                                                this.state
                                                                                                    .latestApprovedPlan,
                                                                                                key1
                                                                                            )}
                                                                                        </a>
                                                                                    )}
                                                                                </TableCell>
                                                                            ) : (
                                                                                ''
                                                                            )}

                                                                            <TableCell align="center">
                                                                                {Moment(
                                                                                    this.state.latestApprovedPlan?.[
                                                                                        'created_date'
                                                                                    ]
                                                                                ).format('DD MMM YYYY')}
                                                                            </TableCell>
                                                                            <TableCell align="center">
                                                                                {this.state.latestApprovedPlan?.[
                                                                                    'approved_flag'
                                                                                ] ? (
                                                                                    <DoneIcon />
                                                                                ) : (
                                                                                    <ErrorOutlineIcon />
                                                                                )}
                                                                            </TableCell>
                                                                            <TableCell align="center">
                                                                                {this.state.latestApprovedPlan?.[
                                                                                    'approval_date'
                                                                                ]
                                                                                    ? Moment(
                                                                                          this.state
                                                                                              .latestApprovedPlan?.[
                                                                                              'approval_date'
                                                                                          ]
                                                                                      ).format('YYYY-MM-DD')
                                                                                    : getFromObj(
                                                                                          this.props.lang,
                                                                                          'dict.pages.treatmentapproval.notapproved'
                                                                                      )}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                            )}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </>
                                        ) : (
                                            <Box marginTop={8} p={1} border={1} style={{ borderStyle: 'dotted' }}>
                                                <p align="center">No Approved Plan Yet</p>
                                            </Box>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <h3>
                                            {getFromObj(
                                                this.props.lang,
                                                'dict.pages.treatmentapproval.all_treatment_plans_by_date'
                                            )}
                                        </h3>
                                        {this.state.treatment_plan
                                            .slice(0)
                                            .reverse()
                                            .map((refinement, rindex, arr) => (
                                                <ExpansionPanel defaultExpanded={rindex == 0 ? true : false}>
                                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            justifyContent="space-between"
                                                            alignItems="flex-start"
                                                        >
                                                            <Typography>
                                                                {' '}
                                                                {arr.length - rindex - 1 == 0
                                                                    ? getFromObj(
                                                                          this.props.lang,
                                                                          'dict.pages.treatmentapproval.first_production'
                                                                      )
                                                                    : // two map to reduce [[]]
                                                                      refinement.map((row, index) =>
                                                                          index
                                                                              ? ''
                                                                              : // check weather it is refinement or defect_resubmit
                                                                                row.defect_resubmit_flag === true
                                                                                ? getFromObj(
                                                                                      this.props.lang,
                                                                                      'dict.pages.treatmentapproval.defect_resubmit'
                                                                                  ) +
                                                                                  ' ' +
                                                                                  row.refinement_no
                                                                                : getFromObj(
                                                                                      this.props.lang,
                                                                                      'dict.pages.treatmentapproval.refinement'
                                                                                  ) +
                                                                                  ' ' +
                                                                                  row.refinement_no
                                                                      )}
                                                            </Typography>
                                                            {smileDesignProductListArray.includes(
                                                                this.state.patientInfo?.case_type
                                                            ) &&
                                                                !['ADMIN', 'SADMIN', 'DISTR'].includes(
                                                                    this.state.role
                                                                ) &&
                                                                ['PLAN_UPLOADED', 'UPGRADE_REQUEST'].includes(
                                                                    this.state.patientInfo?.case_status
                                                                ) && (
                                                                    <ClinicalRequesMultipleModalButtons
                                                                        caseId={this.state.caseId}
                                                                        planId={undefined}
                                                                        disabled={['UPGRADE_REQUEST'].includes(
                                                                            this.state.patientInfo?.case_status
                                                                        )}
                                                                    />
                                                                )}
                                                        </Grid>
                                                    </ExpansionPanelSummary>
                                                    {refinement &&
                                                        refinement
                                                            .slice(0)
                                                            .reverse()
                                                            .map((row, index, plans) => (
                                                                <ExpansionPanelDetails>
                                                                    <Box width="100%">
                                                                        <ExpansionPanel
                                                                            defaultExpanded={
                                                                                rindex == 0 && index == 0 ? true : false
                                                                            }
                                                                        >
                                                                            {/* <Typography>Refinement {index +1}</Typography> */}

                                                                            <ExpansionPanelSummary
                                                                                expandIcon={<ExpandMoreIcon />}
                                                                                style={{
                                                                                    backgroundColor: row[
                                                                                        'approved_flag'
                                                                                    ]
                                                                                        ? '#a7d2a5'
                                                                                        : '#c7c7c7',
                                                                                }}
                                                                            >
                                                                                {/* <Grid item xs={12}
                                        style={arr.length === 1 || rindex === 0 || index > 0 ? {display: 'none'} : {
                                          display: undefined,
                                          paddingTop: 30
                                        }}>
                                    {arr.length !== 1 && rindex !== 0 && index === 0 &&
                                    <hr style={{background: 'black', height: 2}}/>}
                                    <p style={{
                                      padding: '10px 20px',
                                      paddingBottom: '0px',
                                      fontWeight: 700,
                                      fontSize: 'larger'
                                    }}>Refinement #{rindex}</p>
                                  </Grid> */}
                                                                                <Grid
                                                                                    item
                                                                                    xs={12}
                                                                                    sm={12}
                                                                                    md={12}
                                                                                    justify="space-between"
                                                                                    container
                                                                                >
                                                                                    <div
                                                                                        className={
                                                                                            externalCss.planUpdated
                                                                                        }
                                                                                    >
                                                                                        {[
                                                                                            'DISTR',
                                                                                            'ADMIN',
                                                                                            'SADMIN',
                                                                                        ].includes(this.state.role) &&
                                                                                        this.state.patientInfo.case_type !==
                                                                                            CASE_TYPE.SELF_DESIGN ? (
                                                                                            <Box mr={1} boxShadow={0}>
                                                                                                <Button
                                                                                                    style={{
                                                                                                        backgroundColor:
                                                                                                            '#000000',
                                                                                                        color: '#ffffff',
                                                                                                    }}
                                                                                                    size="small"
                                                                                                    variant="contained"
                                                                                                    disableElevation
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        this.setState({
                                                                                                            currentTreatmentPlanIDforModal:
                                                                                                                row[
                                                                                                                    'plan_id'
                                                                                                                ],
                                                                                                        });

                                                                                                        this.handleOpen(
                                                                                                            'treatment'
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    <EditIcon
                                                                                                        style={{
                                                                                                            fontSize: 20,
                                                                                                            marginRight:
                                                                                                                '5px',
                                                                                                        }}
                                                                                                    ></EditIcon>{' '}
                                                                                                    {getFromObj(
                                                                                                        this.props.lang,
                                                                                                        'dict.pages.treatmentapproval.edit_plan'
                                                                                                    )}
                                                                                                </Button>
                                                                                            </Box>
                                                                                        ) : null}
                                                                                        <p>
                                                                                            {getFromObj(
                                                                                                this.props.lang,
                                                                                                'dict.pages.treatmentapproval.treatment_plan_status'
                                                                                            ).replace(
                                                                                                /\{No[^\}]*\?\}/,
                                                                                                row.plan_no ?? index + 1
                                                                                            )}

                                                                                            {row['approved_flag']
                                                                                                ? getFromObj(
                                                                                                      this.props.lang,
                                                                                                      'dict.pages.treatmentapproval.approved'
                                                                                                  )
                                                                                                : getFromObj(
                                                                                                      this.props.lang,
                                                                                                      'dict.pages.treatmentapproval.notapproved'
                                                                                                  )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div>
                                                                                        {![
                                                                                            'ADMIN',
                                                                                            'SADMIN',
                                                                                            'DISTR',
                                                                                        ].includes(this.state.role) &&
                                                                                            !row['approved_flag'] &&
                                                                                            this.state.patientInfo
                                                                                                ?.case_status ===
                                                                                                'PLAN_UPLOADED' &&
                                                                                            !approvedRefinement?.has?.(
                                                                                                row.refinement_no
                                                                                            ) &&
                                                                                            !plans.some(
                                                                                                (v) => v.approved_flag
                                                                                            ) && (
                                                                                                <>
                                                                                                    {this.state
                                                                                                        .patientInfo
                                                                                                        .case_type ===
                                                                                                    CASE_TYPE.SELF_DESIGN ? (
                                                                                                        <a
                                                                                                            href={getWebAbsPath(
                                                                                                                `meditReview/${this.state.caseId}?planNo=${row.plan_no}`
                                                                                                            )}
                                                                                                            target="_blank"
                                                                                                            style={{
                                                                                                                textDecoration:
                                                                                                                    'none',
                                                                                                            }}
                                                                                                            rel="noreferrer"
                                                                                                        >
                                                                                                            <Button
                                                                                                                variant="outlined"
                                                                                                                style={{
                                                                                                                    backgroundColor:
                                                                                                                        '#455793',
                                                                                                                    color: 'white',
                                                                                                                }}
                                                                                                            >
                                                                                                                {this.get(
                                                                                                                    'treatmentPlan.reviewDesign'
                                                                                                                )}
                                                                                                            </Button>
                                                                                                        </a>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <Button
                                                                                                                variant="outlined"
                                                                                                                onClick={(
                                                                                                                    e
                                                                                                                ) => {
                                                                                                                    this.handleApproveTreatmentPlanFromMultiplePlan(
                                                                                                                        row
                                                                                                                    );
                                                                                                                    e.stopPropagation();
                                                                                                                }}
                                                                                                                style={{
                                                                                                                    backgroundColor:
                                                                                                                        '#455793',
                                                                                                                    color: 'white',
                                                                                                                }}
                                                                                                            >
                                                                                                                {this.get(
                                                                                                                    'treatmentPlan.approvePlan'
                                                                                                                )}
                                                                                                            </Button>
                                                                                                            <ClinicalApprovementModal
                                                                                                                planId={
                                                                                                                    row[
                                                                                                                        'plan_id'
                                                                                                                    ]
                                                                                                                }
                                                                                                                caseId={
                                                                                                                    this
                                                                                                                        .state
                                                                                                                        .caseId
                                                                                                                }
                                                                                                            />
                                                                                                            {this.state
                                                                                                                .selectedInMultiPlanId ===
                                                                                                                row[
                                                                                                                    'plan_id'
                                                                                                                ] && (
                                                                                                                <UpgradeAlignerCaseTypeModal
                                                                                                                    openExtenal={
                                                                                                                        this
                                                                                                                            .state
                                                                                                                            .openUpgradeTreatmentPlanMultiPlanModal
                                                                                                                    }
                                                                                                                    handleOpenExternal={() =>
                                                                                                                        this.setState(
                                                                                                                            {
                                                                                                                                openUpgradeTreatmentPlanMultiPlanModal: false,
                                                                                                                            }
                                                                                                                        )
                                                                                                                    }
                                                                                                                    planId={
                                                                                                                        this
                                                                                                                            .state
                                                                                                                            .selectedInMultiPlanId
                                                                                                                    }
                                                                                                                    caseId={
                                                                                                                        this
                                                                                                                            .state
                                                                                                                            .caseId
                                                                                                                    }
                                                                                                                />
                                                                                                            )}
                                                                                                        </>
                                                                                                    )}
                                                                                                </>
                                                                                            )}
                                                                                    </div>
                                                                                </Grid>
                                                                            </ExpansionPanelSummary>

                                                                            <ExpansionPanelDetails
                                                                                style={{ padding: '0px' }}
                                                                            >
                                                                                <TableContainer component={Paper}>
                                                                                    <Box
                                                                                        display="flex"
                                                                                        flexDirection="row-reverse"
                                                                                    ></Box>
                                                                                    <Table aria-label="simple table">
                                                                                        <TableHead>
                                                                                            <TableRow>
                                                                                                <TableCell align="center">
                                                                                                    {this.get(
                                                                                                        'treatmentPlan.fileName'
                                                                                                    )}
                                                                                                </TableCell>
                                                                                                <TableCell align="center">
                                                                                                    {this.get(
                                                                                                        'treatmentPlan.submissionDate'
                                                                                                    )}
                                                                                                </TableCell>
                                                                                                <TableCell align="center">
                                                                                                    {this.get(
                                                                                                        'treatmentPlan.approved'
                                                                                                    )}
                                                                                                </TableCell>
                                                                                                <TableCell align="center">
                                                                                                    {this.get(
                                                                                                        'treatmentPlan.approvedDate'
                                                                                                    )}
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                        </TableHead>
                                                                                        <TableBody>
                                                                                            {/* {Object.keys(row)[0]} */}
                                                                                            {isValidUrl(row['url']) && (
                                                                                                <TableRow>
                                                                                                    <TableCell align="center">
                                                                                                        {!this.state
                                                                                                            .isLoading &&
                                                                                                            (/^https?:\/\/.*idesign\./.test(
                                                                                                                row[
                                                                                                                    'url'
                                                                                                                ]
                                                                                                            ) ||
                                                                                                            /^https?:\/\/.*idesigndev\./.test(
                                                                                                                row[
                                                                                                                    'url'
                                                                                                                ]
                                                                                                            ) ? (
                                                                                                                <a
                                                                                                                    href="#"
                                                                                                                    onClick={(
                                                                                                                        event
                                                                                                                    ) => {
                                                                                                                        event.preventDefault();
                                                                                                                        !this
                                                                                                                            .state
                                                                                                                            .notificationContent ||
                                                                                                                        !this
                                                                                                                            .state
                                                                                                                            .notificationContent
                                                                                                                            .length
                                                                                                                            ? window.open(
                                                                                                                                  row[
                                                                                                                                      'url'
                                                                                                                                  ] +
                                                                                                                                      this.modifyHideRayFace(
                                                                                                                                          row[
                                                                                                                                              'approved_flag'
                                                                                                                                          ]
                                                                                                                                      ),
                                                                                                                                  '_blank'
                                                                                                                              )
                                                                                                                            : this.setState(
                                                                                                                                  {
                                                                                                                                      popupConfirmUrl:
                                                                                                                                          row[
                                                                                                                                              'url'
                                                                                                                                          ] +
                                                                                                                                          this.modifyHideRayFace(
                                                                                                                                              row[
                                                                                                                                                  'approved_flag'
                                                                                                                                              ]
                                                                                                                                          ),
                                                                                                                                      showPopup: true,
                                                                                                                                  }
                                                                                                                              );
                                                                                                                    }}
                                                                                                                    style={{
                                                                                                                        textDecoration:
                                                                                                                            'none',
                                                                                                                        color: '#4d4dbf',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {this.get(
                                                                                                                        'treatmentPlan.view_3DSimulation'
                                                                                                                    )}
                                                                                                                </a>
                                                                                                            ) : (
                                                                                                                <a
                                                                                                                    href={
                                                                                                                        row[
                                                                                                                            'url'
                                                                                                                        ] +
                                                                                                                        '&userid=' +
                                                                                                                        JSON.parse(
                                                                                                                            localStorage.getItem(
                                                                                                                                'auth-token'
                                                                                                                            )
                                                                                                                        ) +
                                                                                                                        this.modifyHideInterware(
                                                                                                                            row[
                                                                                                                                'approved_flag'
                                                                                                                            ]
                                                                                                                        )
                                                                                                                    }
                                                                                                                    target="_blank"
                                                                                                                    style={{
                                                                                                                        textDecoration:
                                                                                                                            'none',
                                                                                                                        color: '#4d4dbf',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {this.get(
                                                                                                                        'treatmentPlan.view_3DSimulation'
                                                                                                                    )}
                                                                                                                </a>
                                                                                                            ))}
                                                                                                    </TableCell>
                                                                                                    <TableCell align="center">
                                                                                                        {Moment(
                                                                                                            row[
                                                                                                                'created_date'
                                                                                                            ]
                                                                                                        ).format(
                                                                                                            'DD MMM YYYY'
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                    <TableCell align="center">
                                                                                                        {row[
                                                                                                            'approved_flag'
                                                                                                        ] ? (
                                                                                                            <DoneIcon />
                                                                                                        ) : (
                                                                                                            <ErrorOutlineIcon />
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                    <TableCell align="center">
                                                                                                        {row[
                                                                                                            'approval_date'
                                                                                                        ]
                                                                                                            ? Moment(
                                                                                                                  row[
                                                                                                                      'approval_date'
                                                                                                                  ]
                                                                                                              ).format(
                                                                                                                  'YYYY-MM-DD'
                                                                                                              )
                                                                                                            : getFromObj(
                                                                                                                  this
                                                                                                                      .props
                                                                                                                      .lang,
                                                                                                                  'dict.pages.treatmentapproval.notapproved'
                                                                                                              )}
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )}
                                                                                            {this.renderSelfDesignSimulationRow(
                                                                                                row
                                                                                            )}
                                                                                            {Object.keys(row).map(
                                                                                                (key1, index1) =>
                                                                                                    this.fileExist(
                                                                                                        row,
                                                                                                        key1
                                                                                                    ) && (
                                                                                                        <TableRow>
                                                                                                            {key1 !==
                                                                                                                'url' && (
                                                                                                                <TableCell align="center">
                                                                                                                    {[
                                                                                                                        this.fileMapping()?.[
                                                                                                                            'smileDesign_exocad_pre_name'
                                                                                                                        ]
                                                                                                                            ?.key,
                                                                                                                    ].includes(
                                                                                                                        key1
                                                                                                                    ) ? (
                                                                                                                        <a
                                                                                                                            href={`${window.location.origin}/clinicalSimulation/${this.state.caseId}`}
                                                                                                                            target="_blank"
                                                                                                                            style={{
                                                                                                                                textDecoration:
                                                                                                                                    'none',
                                                                                                                                color: '#4d4dbf',
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            {this.fileExist(
                                                                                                                                row,
                                                                                                                                key1
                                                                                                                            )}
                                                                                                                        </a>
                                                                                                                    ) : (
                                                                                                                        <a
                                                                                                                            href={
                                                                                                                                row?.[
                                                                                                                                    key1.replace(
                                                                                                                                        '_name',
                                                                                                                                        ''
                                                                                                                                    )
                                                                                                                                ]
                                                                                                                                    ? join(
                                                                                                                                          ApiServerUrl,
                                                                                                                                          row[
                                                                                                                                              key1.replace(
                                                                                                                                                  '_name',
                                                                                                                                                  ''
                                                                                                                                              )
                                                                                                                                          ]
                                                                                                                                      )
                                                                                                                                    : ''
                                                                                                                            }
                                                                                                                            target="_blank"
                                                                                                                            style={{
                                                                                                                                textDecoration:
                                                                                                                                    'none',
                                                                                                                                color: '#4d4dbf',
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            {this.fileExist(
                                                                                                                                row,
                                                                                                                                key1
                                                                                                                            )}
                                                                                                                        </a>
                                                                                                                    )}
                                                                                                                </TableCell>
                                                                                                            )}

                                                                                                            <TableCell align="center">
                                                                                                                {Moment(
                                                                                                                    row[
                                                                                                                        'created_date'
                                                                                                                    ]
                                                                                                                ).format(
                                                                                                                    'DD MMM YYYY'
                                                                                                                )}
                                                                                                            </TableCell>
                                                                                                            <TableCell align="center">
                                                                                                                {row[
                                                                                                                    'approved_flag'
                                                                                                                ] ? (
                                                                                                                    <DoneIcon />
                                                                                                                ) : (
                                                                                                                    <ErrorOutlineIcon />
                                                                                                                )}
                                                                                                            </TableCell>
                                                                                                            <TableCell align="center">
                                                                                                                {row[
                                                                                                                    'approval_date'
                                                                                                                ]
                                                                                                                    ? Moment(
                                                                                                                          row[
                                                                                                                              'approval_date'
                                                                                                                          ]
                                                                                                                      ).format(
                                                                                                                          'YYYY-MM-DD'
                                                                                                                      )
                                                                                                                    : getFromObj(
                                                                                                                          this
                                                                                                                              .props
                                                                                                                              .lang,
                                                                                                                          'dict.pages.treatmentapproval.notapproved'
                                                                                                                      )}
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                    )
                                                                                            )}
                                                                                        </TableBody>
                                                                                    </Table>
                                                                                </TableContainer>
                                                                            </ExpansionPanelDetails>
                                                                        </ExpansionPanel>
                                                                    </Box>
                                                                </ExpansionPanelDetails>
                                                            ))}
                                                </ExpansionPanel>
                                                // <Grid container>
                                                // </Grid>
                                                // </Grid>
                                            ))}
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Animated>
            </>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        config: store.config.config,
        lang: store.lang,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        showSnackbar: (message, variant, queue = false) => dispatch(easySnackbar(message, variant, queue)),
        setIsClinicalSmulationApproveTreatmentPlan: (bool) =>
            dispatch(setIsClinicalSmulationApproveTreatmentPlan(bool)),
        setPlanId: (value) => dispatch(setPlanId(value)),
        openRedirectUserModal: (value) =>
            dispatch(
                openModal({
                    modalTitle: value.title,
                    modalMessage: value.message,
                    modalCallbackFunc: value.modalCallbackFunc,
                    modalOnCloseCallbackFunc: value.modalOnCloseCallbackFunc,
                    showOk: value.showOk,
                })
            ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLang(TreatmentApproval, 'PatientInfo')));
